import { where, pick, path } from 'ramda'
import { isString, isSafeInteger, isNumber } from 'lodash'
import { mapState } from 'vuex'

export const BG_TYPES = {
  GRADIENT: 'Gradient',
  NORMAL: 'Normal'
}

/**
 * @typedef {{
 *   hex: string,
 *   rgba: {
 *     r: number,
 *     g: number
 *     b: number,
 *     a: number
 *   }
 * }} ColorObj
 * @param {ColorObj} colorObj
 * @returns {boolean}
 */
export const colorValidator = colorObj => {
  const validator = where({
    hex: isString,
    rgba: where({
      r: isNumber,
      g: isNumber,
      b: isNumber,
      a: isNumber
    })
  })
  return validator(colorObj)
}

/**
 * @typedef {{
 *   type: string,
 *   gradient: {
 *     from: ColorObj,
 *     to: ColorObj
 *   }
 * }} Background
 *
 * @param {Background} value
 * @returns {boolean}
 */
export const backgroundValidator = value => {
  const shapeValidator = where({
    type: isString,
    gradient: where({
      from: colorValidator,
      to: colorValidator
    })
  })
  return shapeValidator(value)
}

/**
 * @typedef {{
 *   size: number,
 *   family: string,
 *   color: ColorObj
 * }} RegularText
 * @param {RegularText} textParamsObj
 * @returns {boolean}
 */
export const basicTextValidate = textParamsObj => {
  const validator = where({
    size: isSafeInteger,
    family: isString,
    color: colorValidator
  })
  return validator(textParamsObj)
}

/**
 * @typedef {{
 *   size: number,
 *   family: string,
 *   color: ColorObj,
 *   hoverColor: ColorObj
 * }} LinkText
 * @param {LinkText} linksParamsObj
 * @returns {boolean}
 */
export const linkTextValidate = linksParamsObj => {
  const validator = where({
    size: isSafeInteger,
    family: isString,
    color: colorValidator,
    hoverColor: colorValidator
  })
  return validator(linksParamsObj)
}

/**
 * @returns {ColorObj}
 */
export const generateDefaultColor = () => ({
  hex: '#000000',
  rgba: {
    r: 0,
    g: 0,
    b: 0,
    a: 1
  }
})

/**
 * @param {number} size
 * @returns {RegularText}
 */
export const generateDefaultTextFonts = (size = 14) => ({
  size,
  family: 'Montserrat',
  color: generateDefaultColor()
})

/**
 * @param {number} size
 * @returns {LinkText}
 */
export const generateDefaultLinkParams = (size = 14) => ({
  ...generateDefaultTextFonts(size),
  hoverColor: generateDefaultColor()
})

/**
 * @returns {Background}
 */
export const generateDefaultBackgroundParams = () => ({
  type: BG_TYPES.GRADIENT,
  gradient: {
    from: generateDefaultColor(),
    to: generateDefaultColor()
  }
})

export const generateMapState = (key) => {
  return mapState({
    currentSettings: state => {
      return path(['generalSettings', 'settings', 'globalStyleSettings', key], state)
    }
  })
}

export const getColorsParams = pick(['hex', 'rgba'])



// WEBPACK FOOTER //
// ./src/components/pages/GeneralSettings/StylesSettings/styleForms/utils.js